export default "__VITE_ASSET__C2lxMHP0__"